import exchange from "@/store/app/office/recovery/exchange/exchange";
import sharePoint from "@/store/app/office/recovery/share-point/sharePoint";
import oneDrive from "@/store/app/office/recovery/one-drive/oneDrive"
import team from "@/store/app/office/recovery/team/team";
import user from "@/store/app/office/recovery/user"

export default {
  namespaced: true,

  actions: {},

  modules: {
    exchange,
    oneDrive,
    sharePoint,
    team,
    user,
  }
}
